import React from "react";
import { DumontMessage, DumontAvatar, DumontMessageBubble } from "Components/DumontSidebar/styles";
import { DumontLogo } from "Components/Generic/Icons";

export interface DumontReplyBubbleProps {
  children: React.ReactNode;
}

export default function DumontReplyBubble({ children }: DumontReplyBubbleProps) {
  return (
    <DumontMessage>
      <DumontAvatar>
        <DumontLogo size={16} />
      </DumontAvatar>
      <DumontMessageBubble>{children}</DumontMessageBubble>
    </DumontMessage>
  );
}

